'use strict';

const Container = require('./../../core/container');

module.exports = {
  'events': {
    'menu:more-parameters:ready': [
      {
        'callback': function(items) {
          if (Container.get('isAllowedTo')('TAG_FEATURE')) {
            items.push({'name': 'tag_management', 'pos': 4});
          }
        },
      },
    ],
    'menu:more-parameters:tag_management:click': [
      {'callback': require('./views/settings').onMenuClick},
    ],
  },
};
